"use strict";

var _slicedToArray = require("/Users/ahmed/Documents/Projects/Web/freightagewebsite/freightagewebsite/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var enhancers_1 = require("./enhancers");

var expand_aliases_1 = __importDefault(require("./expand-aliases"));

var cache = __importStar(require("./cache"));

var styles = __importStar(require("./styles"));

function enhanceProps(rawProps) {
  var propsMap = expand_aliases_1.default(rawProps);
  var preservedProps = {};
  var className = rawProps.className || '';
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = propsMap[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref3 = _step.value;

      var _ref2 = _slicedToArray(_ref3, 2);

      var propName = _ref2[0];
      var propValue = _ref2[1];
      var cachedClassName = cache.get(propName, propValue);

      if (cachedClassName) {
        className = "".concat(className, " ").concat(cachedClassName);
        continue;
      }

      var enhancer = enhancers_1.propEnhancers[propName];

      if (enhancer && (propValue === null || propValue === undefined || propValue === false)) {
        continue;
      } else if (!enhancer) {
        preservedProps[propName] = propValue;
        continue;
      }

      var newCss = enhancer(propValue);

      if (newCss) {
        styles.add(newCss.styles);
        cache.set(propName, propValue, newCss.className);
        className = "".concat(className, " ").concat(newCss.className);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  className = className.trim();
  return {
    className: className,
    enhancedProps: preservedProps
  };
}

exports.default = enhanceProps;